import React from 'react';
import { TiltCard } from './TiltCard';
import { universes } from '../../../data/universes';
const layout = [{
  size: 'hero' as const,
  className: 'h-[480px] md:col-span-2 lg:col-span-7 lg:row-span-2 lg:h-auto'
}, {
  size: 'standard' as const,
  className: 'h-[380px] lg:col-span-5 lg:h-auto'
}, {
  size: 'standard' as const,
  className: 'h-[380px] lg:col-span-5 lg:h-auto'
}, {
  size: 'wide' as const,
  className: 'h-[380px] md:col-span-2 lg:col-span-12 lg:h-auto'
}];
export function Universes() {
  return <section aria-labelledby="universes-title" className="bg-paper py-24 md:py-32" data-id="element-243" data-mp="e7ubnvksw3sq">
      <div className="shell" data-id="element-244" data-mp="9vxaq6hc7d8">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-245" data-mp="8ktwrgy51mn">
          <h2 id="universes-title" className="text-[clamp(36px,5vw,72px)] font-medium leading-[0.98] tracking-[-0.04em] lg:col-span-7" data-id="element-246" data-mp="49y1p73lnew7">
            Quatre univers.
            <br data-id="element-247" data-mp="2p16v96ab93ok" />
            Un seul atelier.
          </h2>
          <p className="max-w-md text-lg leading-relaxed text-mute lg:col-span-5" data-id="element-248" data-mp="2oyls8dya0hp8">
            Choisissez votre typologie de projet : chaque univers a ses contraintes, nous les connaissons par cœur.
          </p>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-12 lg:grid-rows-[340px_340px_320px]" data-id="element-249" data-mp="3cbjczpbjms49">
          {universes.map((u, i) => <TiltCard key={u.id} universe={u} size={layout[i].size} className={layout[i].className} data-id="element-250" data-mp="3884veu7yi3op" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}